import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import lodash from "lodash";

import Signature from "../Signature";

class RecordSignature extends React.Component {
  render() {
    const {
      signatureField,
      recordedSignatures,
      handlerChangeSignature
    } = this.props;

    const recordedSignature = lodash.find(recordedSignatures, { meta_id: signatureField.id });

    return (
      <div>
        {recordedSignature && !recordedSignature._destroy ? (
          <label className="control-label">
            Click to edit signature of {signatureField.name}
          </label>
        ) : null}

        <Signature
          signatureId={signatureField.id}
          signature={recordedSignature && recordedSignature.data_image}
          title={`${signatureField.name} Signature`}
          onDone={handlerChangeSignature}
        >
          <div className="btn btn-text btn-signature">
            Add {signatureField.name} Signature{signatureField.required ? " [REQUIRED]" : ""}
          </div>
        </Signature>
      </div>
    );
  }
}

class DigiFormRecordSignature extends React.Component {
  state = {
    recordedSignatures: this.props.value || []
  };

  render() {
    const {
      fieldErrors,
      associationName,
      onChange,
      signatureFields
    } = this.props;

    const {
      recordedSignatures
    } = this.state;

    return (
      signatureFields.map(signatureField => (
        <div className={classnames("form-group", { "has-error": fieldErrors })}>
          <RecordSignature
            signatureField={signatureField}
            recordedSignatures={recordedSignatures}
            handlerChangeSignature={this.handlerChangeSignature}
          />
          {fieldErrors[signatureField.name] && signatureField.required == true ? (
            <span className="help-block">{fieldErrors[signatureField.name]}</span>
          ) : null}
        </div>
      ))
    );
  }

  handlerChangeSignature = (dataImage, deletion, signatureId) => {
    const recordedSignatures = this.state.recordedSignatures;
    const idx = lodash.findIndex(recordedSignatures, { meta_id: signatureId });


    if (idx === -1) {
      recordedSignatures.push({
        meta_id: signatureId,
        data_image: dataImage,
        _id: new Date().getTime()
      });
    } else {
      if (dataImage) {

        recordedSignatures[idx].data_image = dataImage;
        recordedSignatures[idx]._destroy = false;
      } else {
        if (recordedSignatures[idx].id) {
          recordedSignatures[idx].data_image = null;
          recordedSignatures[idx]._destroy = true;
        } else {
          recordedSignatures.splice(idx, 1);
        }
      }
    }

    this.setState({ recordedSignatures: recordedSignatures, fieldErrors: {} });
    this.props.onChange(recordedSignatures, this.props.associationName);
  };
}

DigiFormRecordSignature.propTypes = {
  signatures: PropTypes.array,
  associationName: PropTypes.string,
  fieldErrors: PropTypes.object
};

export default DigiFormRecordSignature;
